import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlay: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconPlay"><Path d="M6.13434 2.10597C5.90259 1.96766 5.6144 1.96454 5.3797 2.09779C5.145 2.23104 5 2.48011 5 2.75V21.25C5 21.5199 5.145 21.769 5.3797 21.9022C5.6144 22.0355 5.90259 22.0323 6.13434 21.894L21.6343 12.644C21.8611 12.5087 22 12.2641 22 12C22 11.7359 21.8611 11.4913 21.6343 11.356L6.13434 2.10597Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPlay;
